export default (to, _, savedPosition) => {
  if (Object.keys(to.query).length !== 0) return 0;
  if (savedPosition) {
    return savedPosition;
  }
  return { x: 0, y: 0 };
};
